import { PageHeader } from '@/shared/ui';
import { TeamPage } from './TeamPage';
import { StaffPage } from './StaffPage';
import styles from './SettingsPage.module.css';

/**
 * Settings > Team & Staff: two lists kept apart on one page. PracticeNova access is who signs in and their role;
 * Practice staff are the people patients meet (named in review requests and replies), who need no sign-in.
 */
export function TeamAndStaffPage() {
  return (
    <div className={styles.page}>
      <PageHeader
        title="Team & Staff"
        subtitle="Who can use PracticeNova, and who works at the practice."
      />
      <TeamPage embedded />
      <StaffPage embedded />
    </div>
  );
}
